import { track } from '@bnnvara/analytics/src/track';
import React from 'react';

import * as S from '../styled';

const TitleButton = () => (
  <S.LeftMenuButton
    type="link"
    href="/catalogus/programmas"
    variant="text"
    onClick={() => {
      track('bnnvara-menu', 'click', 'titels');
    }}
  >
    Titels
  </S.LeftMenuButton>
);

export { TitleButton };
